import type { ReactNode } from 'react';
import { type BaseButtonProps, Button } from '@repo/design-system-kit/components/button/button';
import IconArrowLeftOutlined from '@repo/monochrome-icons/icon-arrow-left-outlined';
import { useIntl } from 'react-intl';

export interface BackButtonProps extends Omit<BaseButtonProps, 'children'> {}

export function BackButton(props: BackButtonProps): ReactNode {
  const intl = useIntl();
  const label = intl.formatMessage({ id: 'generic.back.cta' });

  return (
    <Button
      aria-label={label}
      iconLeft={<IconArrowLeftOutlined />}
      label={label}
      type="button"
      variant="tertiary"
      {...props}
    />
  );
}
